<template>
    <v-dialog v-model="isOpen" max-width="400">
        <div class="dialogClose">
            <div v-on:mousedown.prevent="isOpen = false" v-on:touchstart.prevent="isOpen = false"><img
                    src="/images/common/close.png" /></div>
        </div>
        <div class="dialogBase dialogGet" @click="isOpen = false">
            <v-row class="text-center pa-0 ma-0  mt-5 mb-5">
                <v-col cols="12" class="infoText pb-6">
                    このピースは<br />
                    すでに持っているみたい！
                </v-col>
                <v-col cols="12" class="text-center justify-center">
                    <img src="/images/puzzle/getpiece_same.png" width="60%" />
                </v-col>
            </v-row>
        </div>
    </v-dialog>
</template>
<style scoped>
.infoText {
    font-family: Rounded Mplus 1c, sans-serif;
    font-weight: bold;
    font-size: min(4.2vw, 20px);
}

.dialogGet {
    background-color: white;

}
</style>
<script>

import '@/assets/style/window.css';

export default {
    data: () => ({
        isOpen: true,
    }),
    props: {
    },
    created: function () {

    },
    destroyed: function () {
    },
    methods: {

    },
    computed: {

    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.$emit('close', this.data);
            }
        }
    }
}
</script>